import { frontendURL } from '../../../../helper/URLHelper';

const campaigns = accountId => {
  const menuItems = [
    {
      icon: 'arrow-swap',
      label: 'ONGOING',
      key: 'ongoingCampaigns',
      hasSubMenu: false,
      toState: frontendURL(`accounts/${accountId}/campaigns/ongoing`),
      toStateName: 'ongoing_campaigns',
    },
    {
      key: 'oneOffCampaigns',
      icon: 'sound-source',
      label: 'ONE_OFF',
      hasSubMenu: false,
      toState: frontendURL(`accounts/${accountId}/campaigns/one_off`),
      toStateName: 'one_off',
    },
    {
      key: 'whatsappCampaigns',
      icon: 'brand-whatsapp',
      label: 'WHATSAPP',
      hasSubMenu: false,
      toState: frontendURL(`accounts/${accountId}/campaigns/whatsapp_campaigns`),
      toStateName: 'whatsapp_campaigns',
    }
  ];

  // if (accountId === 4) {
  //   menuItems.push({
  //     key: 'whatsappCampaigns',
  //     icon: 'brand-whatsapp',
  //     label: 'WHATSAPP',
  //     hasSubMenu: false,
  //     toState: frontendURL(`accounts/${accountId}/campaigns/whatsapp_campaigns`),
  //     toStateName: 'whatsapp_campaigns',
  //   });
  // }

  return {
    parentNav: 'campaigns',
    // routes: ['ongoing_campaigns', 'one_off', ...(accountId === 4 ? ['whatsapp_campaigns'] : [])],
    routes: ['ongoing_campaigns', 'one_off', 'whatsapp_campaigns'],
    menuItems,
  };
};

export default campaigns;
